import { render } from "./paginationComponent.vue?vue&type=template&id=1367c60a"
import script from "./paginationComponent.vue?vue&type=script&lang=js"
export * from "./paginationComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__